import { render } from "./area_title.vue?vue&type=template&id=344e90ce"
import script from "./area_title.vue?vue&type=script&lang=js"
export * from "./area_title.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/area_title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "344e90ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('344e90ce', __exports__)) {
    api.reload('344e90ce', __exports__)
  }
  
  module.hot.accept("./area_title.vue?vue&type=template&id=344e90ce", () => {
    api.rerender('344e90ce', render)
  })

}


export default __exports__